<template>
  <div v-if="inline" class="repeating-event-inline">
    <div class="d-flex flex-column drop-container">
      <select
        class="form-select re-input"
        aria-label="Default select example"
        v-model="repeatingType"
        :disabled="repeatingEvent"
      >
        <option value="">{{ $t("todoDetails.noRepeat") }}</option>
        <option value="3">{{ $t("todoDetails.daily") }}</option>
        <option value="2">{{ $t("todoDetails.weekly") }}</option>
        <option value="4">{{ $t("todoDetails.weekdays") }}</option>
        <option value="5">{{ $t("todoDetails.customWeekdays") }}</option>
        <option value="1">{{ $t("todoDetails.monthly") }}</option>
        <option value="6">{{ $t("todoDetails.daysOfMonth") }}</option>
        <option value="0">{{ $t("todoDetails.yearly") }}</option>
      </select>

      <div v-if="repeatingType" class="d-flex flex-column">
        <div v-show="repeatingType == '5' || (repeatingEvent && repeatingType == '2')" class="weekDays-selector mt-3 mb-1">
          <input type="checkbox" :disabled="repeatingEvent" :id="uid + '-mon'" class="weekday" v-model="weekdays.mon" />
          <label :for="uid + '-mon'">{{ moments().isoWeekday(1).locale(language).format("dd")[0] }}</label>
          <input type="checkbox" :disabled="repeatingEvent" :id="uid + '-tue'" class="weekday" v-model="weekdays.tue" />
          <label :for="uid + '-tue'">{{ moments().isoWeekday(2).locale(language).format("dd")[0] }}</label>
          <input type="checkbox" :disabled="repeatingEvent" :id="uid + '-wed'" class="weekday" v-model="weekdays.wed" />
          <label :for="uid + '-wed'">{{ moments().isoWeekday(3).locale(language).format("dd")[0] }}</label>
          <input type="checkbox" :disabled="repeatingEvent" :id="uid + '-thu'" class="weekday" v-model="weekdays.thu" />
          <label :for="uid + '-thu'">{{ moments().isoWeekday(4).locale(language).format("dd")[0] }}</label>
          <input type="checkbox" :disabled="repeatingEvent" :id="uid + '-fri'" class="weekday" v-model="weekdays.fri" />
          <label :for="uid + '-fri'">{{ moments().isoWeekday(5).locale(language).format("dd")[0] }}</label>
          <input type="checkbox" :disabled="repeatingEvent" :id="uid + '-sat'" class="weekday" v-model="weekdays.sat" />
          <label :for="uid + '-sat'">{{ moments().isoWeekday(6).locale(language).format("dd")[0] }}</label>
          <input type="checkbox" :disabled="repeatingEvent" :id="uid + '-sun'" class="weekday" v-model="weekdays.sun" />
          <label :for="uid + '-sun'">{{ moments().isoWeekday(7).locale(language).format("dd")[0] }}</label>
        </div>

        <div v-show="repeatingType == '6'" class="mt-3 mb-1">
          <input
            v-model="daysOfMonth"
            type="text"
            class="form-control day-of-month"
            :disabled="repeatingEvent"
            placeholder="1,2,15"
          />
        </div>

        <div class="d-flex align-items-center justify-content-between re-input">
          <label class="opacity-50">{{ $t("todoDetails.interval") }}</label>
          <input type="number" class="form-control lex-shrink-1 counter" v-model="interval" :disabled="repeatingEvent" />
        </div>

        <select
          class="form-select re-input"
          aria-label="Default select example"
          v-model="ocurrencesType"
          :disabled="repeatingEvent"
        >
          <option value="">{{ $t("todoDetails.indefinitely") }}</option>
          <option value="ocurrences">{{ $t("todoDetails.occurrences") }}</option>
          <option value="untilDate">{{ $t("todoDetails.untilDate") }}</option>
        </select>

        <input
          v-if="ocurrencesType == 'ocurrences'"
          type="number"
          class="form-control re-input last-input"
          v-model="ocurrences"
          :disabled="repeatingEvent"
        />
        <input
          v-if="ocurrencesType == 'untilDate'"
          type="date"
          class="form-control re-input last-input"
          v-model="untilDate"
          :disabled="repeatingEvent"
        />
      </div>

      <div class="d-flex flex-row re-form-row re-input">
        <button v-if="!repeatingEvent" type="button" class="btn flex-fill" @click="done">
          {{ $t("todoDetails.done") }}
        </button>
        <button v-if="repeatingEvent" type="button" class="btn flex-fill" @click="split">
          {{ $t("todoDetails.split") }}
        </button>
      </div>
    </div>
  </div>
  <div v-else class="dropdown repeating-event-root">
    <div
      ref="reDropDown"
      class="header-menu-icons"
      type="button"
      data-bs-toggle="dropdown"
      data-bs-auto-close="false"
      data-bs-popper-config='{"strategy":"fixed","placement":"bottom-end"}'
      :title="$t('ui.recurringTasks')"
    >
      <i :class="{ 'bi-arrow-clockwise': !repeatingEvent, 'bi-arrow-repeat': repeatingEvent }"></i>
    </div>

    <ul class="dropdown-menu repeating-event-dropdown">
      <div class="mx-3 d-flex flex-column drop-container">
        <select
          class="form-select re-input"
          aria-label="Default select example"
          v-model="repeatingType"
          :disabled="repeatingEvent"
        >
          <option value="">{{ $t("todoDetails.noRepeat") }}</option>
          <option value="3">{{ $t("todoDetails.daily") }}</option>
          <option value="2">{{ $t("todoDetails.weekly") }}</option>
          <option value="4">{{ $t("todoDetails.weekdays") }}</option>
          <option value="5">{{ $t("todoDetails.customWeekdays") }}</option>
          <option value="1">{{ $t("todoDetails.monthly") }}</option>
          <option value="6">{{ $t("todoDetails.daysOfMonth") }}</option>
          <option value="0">{{ $t("todoDetails.yearly") }}</option>
        </select>

        <div v-if="repeatingType" class="d-flex flex-column">
          <div v-show="repeatingType == '5' || (repeatingEvent && repeatingType == '2')" class="weekDays-selector mt-3 mb-1">
            <input type="checkbox" :disabled="repeatingEvent" id="weekday-mon" class="weekday" v-model="weekdays.mon" />
            <label for="weekday-mon">{{ moments().isoWeekday(1).locale(language).format("dd")[0] }}</label>
            <input type="checkbox" :disabled="repeatingEvent" id="weekday-tue" class="weekday" v-model="weekdays.tue" />
            <label for="weekday-tue">{{ moments().isoWeekday(2).locale(language).format("dd")[0] }}</label>
            <input type="checkbox" :disabled="repeatingEvent" id="weekday-wed" class="weekday" v-model="weekdays.wed" />
            <label for="weekday-wed">{{ moments().isoWeekday(3).locale(language).format("dd")[0] }}</label>
            <input type="checkbox" :disabled="repeatingEvent" id="weekday-thu" class="weekday" v-model="weekdays.thu" />
            <label for="weekday-thu">{{ moments().isoWeekday(4).locale(language).format("dd")[0] }}</label>
            <input type="checkbox" :disabled="repeatingEvent" id="weekday-fri" class="weekday" v-model="weekdays.fri" />
            <label for="weekday-fri">{{ moments().isoWeekday(5).locale(language).format("dd")[0] }}</label>
            <input type="checkbox" :disabled="repeatingEvent" id="weekday-sat" class="weekday" v-model="weekdays.sat" />
            <label for="weekday-sat">{{ moments().isoWeekday(6).locale(language).format("dd")[0] }}</label>
            <input type="checkbox" :disabled="repeatingEvent" id="weekday-sun" class="weekday" v-model="weekdays.sun" />
            <label for="weekday-sun">{{ moments().isoWeekday(7).locale(language).format("dd")[0] }}</label>
          </div>

          <div v-show="repeatingType == '6'" class="mt-3 mb-1">
            <input
              v-model="daysOfMonth"
              type="text"
              class="form-control day-of-month"
              :disabled="repeatingEvent"
              placeholder="1,2,15"
            />
          </div>

          <div class="d-flex align-items-center justify-content-between re-input">
            <label class="opacity-50">{{ $t("todoDetails.interval") }}</label>
            <input type="number" class="form-control lex-shrink-1 counter" v-model="interval" :disabled="repeatingEvent" />
          </div>

          <select
            class="form-select re-input"
            aria-label="Default select example"
            v-model="ocurrencesType"
            :disabled="repeatingEvent"
          >
            <option value="">{{ $t("todoDetails.indefinitely") }}</option>
            <option value="ocurrences">{{ $t("todoDetails.occurrences") }}</option>
            <option value="untilDate">{{ $t("todoDetails.untilDate") }}</option>
          </select>

          <input
            v-if="ocurrencesType == 'ocurrences'"
            type="number"
            class="form-control re-input last-input"
            v-model="ocurrences"
            :disabled="repeatingEvent"
          />
          <input
            v-if="ocurrencesType == 'untilDate'"
            type="date"
            class="form-control re-input last-input"
            v-model="untilDate"
            :disabled="repeatingEvent"
            @mousedown.stop
            @click.stop
          />
        </div>

        <div class="d-flex flex-row re-form-row re-input">
          <button v-if="!repeatingEvent" type="button" class="btn flex-fill" @click="done">
            {{ $t("todoDetails.done") }}
          </button>
          <button v-if="repeatingEvent" type="button" class="btn flex-fill" @click="split">
            {{ $t("todoDetails.split") }}
          </button>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import { RRule, rrulestr } from "rrule";
import repeatingEventRepository from "../../repositories/repeatingEventRepository";
import moment from "moment";
import { Dropdown } from "bootstrap";
import repeatingEventHelper from "../../helpers/repeatingEvents.js";

export default {
  name: "RepatingEvent",
  emits: ["repeatingEventSelected", "close"],
  data() {
    return {
      uid: "re-" + Math.random().toString(36).slice(2, 9),
      repeatingType: "",
      interval: 1,
      ocurrencesType: "",
      ocurrences: 1,
      untilDate: "",
      daysOfMonth: "",
      weekdays: { mon: false, tue: false, wed: false, thu: false, fri: false, sat: false, sun: false },
    };
  },
  props: {
    repeatingEvent: { required: true, type: [String, null] },
    todo: { required: true, type: [Object, null] },
    inline: { type: Boolean, default: false },
  },
  methods: {
    async done() {
      const rule = this.repeatingEventRule();
      var repeatingEventId = this.repeatingEvent ? this.repeatingEvent : moment().format("x");
      if (rule) {
        const re_event = this.generateRepeatingEvent(rule, repeatingEventId);
        try {
          // Persist rule first so refresh / applyWeek cannot drop it
          await repeatingEventRepository.update(repeatingEventId, re_event);
        } catch (error) {
          // Keep going for in-memory UX; toast already emitted by repository
          console.error("repeating_event save failed", error);
        }
        this.$store.commit("updateRepeatingEvent", { key: repeatingEventId, val: re_event });
        this.$store.commit("addRepeatingEventToDateCache", re_event);
        // Capture store before parent re-render; hold applyWeek for link+materialize
        // so gaps between day PUTs cannot refetch empty next-week docs.
        const store = this.$store;
        const vue = { $store: store };
        const seedListId = this.todo && this.todo.listId;
        const { datesForRule } = require("../../helpers/repeatingEventDateRange.js");
        const { withWriteHold } = require("../../sync/sessionSync.js");
        const ruleDays = datesForRule(rule).map((d) => moment.utc(d).format("YYYYMMDD"));
        const days = repeatingEventHelper.daysToMaterialize(
          store.getters.repeatingEventDateCache,
          repeatingEventId,
          [seedListId, ...ruleDays]
        );
        await withWriteHold(async () => {
          // Link seed BEFORE materialize so Monday is not duplicated.
          // Parent must not destroy this component until hideDropdown/@close.
          this.$emit("repeatingEventSelected", repeatingEventId);
          for (const day of days) {
            try {
              await repeatingEventHelper.generateRepeatingEventsIntances(day, vue, {
                hydrate: true,
              });
            } catch (error) {
              console.error("materialize failed", day, error);
            }
          }
        });
      } else {
        try {
          await repeatingEventRepository.remove(repeatingEventId);
        } catch (_) {
          /* toast already emitted */
        }
        repeatingEventId = null;
        this.$emit("repeatingEventSelected", null);
      }

      this.hideDropdown();
    },
    split() {
      repeatingEventRepository.remove(this.repeatingEvent);
      this.hideDropdown();
      this.$emit("repeatingEventSelected", null);
    },
    hideDropdown() {
      if (this.inline) {
        this.$emit("close");
        return;
      }
      const reDropDown = this.$refs.reDropDown;
      if (!reDropDown) return;
      try {
        Dropdown.getOrCreateInstance(reDropDown).hide();
      } catch (e) {
        /* ignore */
      }
    },
    repeatingEventRule() {
      if (!this.repeatingType) return null;

      var ruleOptions = {
        freq: this.repeatingType,
        interval: this.interval,
        dtstart: moment.utc(this.todo.listId, "YYYYMMDD").toDate(),
      };

      if (this.repeatingType == 4) {
        ruleOptions.byweekday = [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR];
        ruleOptions.freq = 2;
      }

      if (this.repeatingType == 5) {
        ruleOptions.byweekday = [];
        this.weekdays.mon && ruleOptions.byweekday.push(RRule.MO);
        this.weekdays.tue && ruleOptions.byweekday.push(RRule.TU);
        this.weekdays.wed && ruleOptions.byweekday.push(RRule.WE);
        this.weekdays.thu && ruleOptions.byweekday.push(RRule.TH);
        this.weekdays.fri && ruleOptions.byweekday.push(RRule.FR);
        this.weekdays.sat && ruleOptions.byweekday.push(RRule.SA);
        this.weekdays.sun && ruleOptions.byweekday.push(RRule.SU);
        ruleOptions.freq = 2;
      }

      if (this.repeatingType == 6) {
        const daysOfMonthArray = this.daysOfMonth.split(",").map((num) => parseInt(num));
        ruleOptions.bymonthday = daysOfMonthArray;
        ruleOptions.freq = 1;
      }

      if (this.ocurrencesType == "ocurrences") {
        const count = parseInt(this.ocurrences, 10);
        if (Number.isFinite(count) && count > 0) ruleOptions.count = count;
      } else if (this.ocurrencesType == "untilDate" && this.untilDate) {
        ruleOptions.until = moment(this.untilDate).endOf("day").toDate();
      }
      return new RRule(ruleOptions);
    },
    generateRepeatingEvent(rule, repeatingEventId) {
      var todo_data = JSON.parse(JSON.stringify(this.todo));
      todo_data.repeatingEvent = repeatingEventId;
      const rule2 = rrulestr(rule.toString()); //Cloning the rule for some error in the library don't works with original rule
      const toIso = (value) => {
        if (!value) return null;
        if (typeof value === "string") return value;
        if (typeof value.toISOString === "function") return value.toISOString();
        const m = moment(value);
        return m.isValid() ? m.toDate().toISOString() : null;
      };
      var re_event = {
        start_date: toIso(rule.options.dtstart),
        repeating_rule: rule.toString(),
        type: String(this.repeatingType),
        ocurrencesType: this.ocurrencesType,
        data: todo_data,
        id: repeatingEventId,
      };

      if (this.ocurrencesType == "ocurrences") {
        re_event.end_date = toIso(rule2.all().slice(-1)[0]);
      } else if (this.ocurrencesType == "untilDate") {
        re_event.end_date = toIso(moment(rule.options.until).toDate());
      } else {
        var date = new Date();
        date.setFullYear(date.getFullYear() + 15);
        re_event.end_date = toIso(date);
      }

      // Ensure payload is structured-clone / JSON safe for IDB + PUT
      return JSON.parse(JSON.stringify(re_event));
    },
    moments: function (date) {
      return moment(date);
    },
    applyRepeatingEvent(newVal) {
      const re = newVal ? this.$store.getters.repeatingEventList[newVal] : null;
      this.weekdays = { mon: false, tue: false, wed: false, thu: false, fri: false, sat: false, sun: false };
      this.daysOfMonth = "";
      if (!re) {
        this.repeatingType = "";
        this.ocurrencesType = "";
        this.interval = 1;
        this.untilDate = "";
        this.ocurrences = null;
        return;
      }
      const rule = rrulestr(re.repeating_rule);
      // select 的 option value 是字符串；优先用保存的 type（0=每年也要保留）
      this.repeatingType =
        re.type != null && re.type !== "" ? String(re.type) : String(rule.options.freq);
      this.interval = rule.options.interval || 1;
      this.ocurrences = rule.options.count || null;
      this.ocurrencesType = re.ocurrencesType || "";
      this.untilDate = rule.options.until ? moment(rule.options.until).format("YYYY-MM-DD") : "";
      if (rule.options.byweekday) {
        const days = rule.options.byweekday;
        this.weekdays.mon = days.includes(0);
        this.weekdays.tue = days.includes(1);
        this.weekdays.wed = days.includes(2);
        this.weekdays.thu = days.includes(3);
        this.weekdays.fri = days.includes(4);
        this.weekdays.sat = days.includes(5);
        this.weekdays.sun = days.includes(6);
      }
      if (rule.options.bymonthday && rule.options.bymonthday.length > 0) {
        this.daysOfMonth = rule.options.bymonthday.join(",");
      }
    },
  },
  watch: {
    repeatingEvent: {
      immediate: true,
      handler(newVal) {
        this.applyRepeatingEvent(newVal);
      },
    },
  },
  computed: {
    language: function () {
      return this.$store.getters.config.language;
    },
  },
};
</script>

<style scoped lang="scss">
@import "/src/assets/style/globalVars.scss";

.header-menu-icons {
  margin-left: 6px;
  @include btn-icon;
}

.repeating-event-dropdown {
  margin-left: -80px !important;
  width: 200px;
}

.repeating-event-inline {
  width: 100%;
}

.repeating-event-inline .drop-container {
  margin: 0;
}

.repeating-event-inline .btn {
  background: #007aff;
  color: #fff;
  border-radius: 10px;
  margin-top: 4px;
}

.re-input {
  margin-top: 10px;
  font-size: 15px;
}

.counter {
  width: 60px;
  border: none;
  border-bottom: 1px solid #ced4da;
  border-radius: unset;
  padding: unset;
}

.last-input {
  border: none;
  border-bottom: 1px solid #ced4da;
  border-radius: unset;
  padding: 5px;
}

.form-control:focus,
.form-select:focus {
  box-shadow: unset;
}

[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 1;
}

.dark-theme input {
  background-color: #21262d;
  color: #c9d1d9;
  border-bottom: 1px solid #464647;
}

.dark-theme .day-of-month {
  background-color: #15161e;
  border: 1px solid #464647;
}

.day-of-month::placeholder {
  color: #9b9b9b;
}

.dark-theme .day-of-month::placeholder {
  color: #838383;
}

.weekDays-selector {
  display: flex;
  justify-content: center;
}

.weekDays-selector input {
  display: none !important;
}

.weekDays-selector input[type="checkbox"] + label {
  display: inline-block;
  border-radius: 3px;
  background: #eaecef;
  height: 20px;
  width: 20px;
  margin-right: 3px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
  text-transform: uppercase;
}

.dark-theme .weekDays-selector input[type="checkbox"] + label {
  background: #15161e;
  color: #ffffff;
}

.weekDays-selector input[type="checkbox"]:disabled + label {
  cursor: unset;
  opacity: 0.6;
}

.weekDays-selector input[type="checkbox"]:checked + label {
  background: #5c5c5c;
  color: #ffffff;
}
</style>
